import { Controller } from "@hotwired/stimulus"

// One state owner prevents nested toggles from re-enabling hidden inputs.
export default class extends Controller {
  static targets = ["commitmentBlock", "content", "customBlock", "renewalBlock"]

  connect() { this.update() }

  update() {
    const form = this.element.closest("form")
    const phasesEnabled = form.querySelector('[data-form-price-phases-target~="toggle"]')?.checked
    const period = phasesEnabled
      ? form.querySelector('select[name^="subscription_type[price_phases_attributes]"][name$="[period]"]:not(:disabled)')?.value
      : form.querySelector('select[name="subscription_type[period]"]')?.value
    const supported = ["month", "quarteryear", "halfyear", "year"].includes(period)
    const checkbox = this.element.querySelector('input[type="checkbox"][name="subscription_type[commitment_enabled]"]')
    if (!checkbox || !this.hasCommitmentBlockTarget) return
    this.commitmentBlockTarget.hidden = !supported
    this.commitmentBlockTarget.style.display = supported ? "" : "none"
    checkbox.disabled = !supported
    const enabled = supported && checkbox.checked
    const custom = this.element.querySelector('select[name="subscription_type[commitment_select_value]"]')?.value === "custom"
    const renewal = this.element.querySelector('input[name="subscription_type[commitment_renewal_enabled]"]:checked')?.value === "1"
    this.setVisible(this.contentTarget, enabled)
    this.setVisible(this.customBlockTarget, enabled && custom)
    if (this.hasRenewalBlockTarget) this.setVisible(this.renewalBlockTarget, enabled && renewal)
  }

  setVisible(element, visible) {
    element.hidden = !visible
    element.querySelectorAll("input, select, textarea").forEach(input => { input.disabled = !visible })
  }
}
